export const RUSH_INTRO_VISIBLE_FOR_FIRST_N_GAMES = 5;
export const RUSH_INTRO_AUTO_OPEN_FOR_FIRST_N_GAMES = 2;
